import Joi from 'joi-browser';

import regex from '../../../utilities/validateRegex';
import { NATIONALITY_INFO, FORM_DATA } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import {
  customValidateDate,
  customValidateDateNotAllowEmpty,
} from '../../../utilities/validateDateUtil';

/**
 * 作業員一覧 労務安全基本情報 タブ でのバリデーション
 * @return {object} バリデーション用のスキーマ
 * */
const createResidentStatusSchema = Joi.extend(joi => ({
  base: joi.number(),
  name: 'number',
  rules: [
    {
      name: 'notForeignLaborConstructor',
      validate(params, value, state, options) {
        const errorMessage = messageUtility.getMessage('E-001-104');
        if (value === 1) {
          return this.createError(
            'customMessage',
            { errorMessage },
            state,
            options
          );
        }
        return value;
      },
    },
  ],
}));

const createValidateSchema = () => {
  const validateSchema = Object.create(null);

  validateSchema.blood_type = Joi.string().allow(null, '');

  // 在留資格
  validateSchema.resident_status = createResidentStatusSchema
    .number()
    .notForeignLaborConstructor();

  // 在留期間満了日
  validateSchema.staying_period_expiration_date = customValidateDate
    .base()
    .validateDate();

  // 経験開始年月日
  validateSchema.experience_start_date = customValidateDate
    .base()
    .validateDate();

  // 雇入年月日
  validateSchema.employer_in_date = customValidateDate.base().validateDate();

  // ブランク期間(月)
  validateSchema.blank_months = Joi.number()
    .integer()
    .min(0)
    .allow(null, '');

  // 雇入時教育年月日
  validateSchema.employment_education_date = customValidateDate
    .base()
    .validateDate();

  validateSchema.postal_code = Joi.string()
    .regex(regex.pattern.zip)
    .allow(null, '');
  validateSchema.tel = Joi.string()
    .regex(regex.pattern.tel)
    .allow(null, '');
  validateSchema.fax = Joi.string()
    .regex(regex.pattern.tel)
    .allow(null, '');
  validateSchema.email = Joi.string()
    .regex(regex.pattern.email)
    .allow(null, '');

  return validateSchema;
};

/**
 * 作業員一覧 労務安全基本情報 タブ での安全書類項目(要入力)バリデーション
 * @return {object} バリデーション用のスキーマ
 * このプロパティ設定の並び順に従って validate が行われる
 * */
const createValidateSchemaSafetyDocItem = ({ foreigner_flag }) => {
  const validateSchema = Object.create(null);

  // ABO血液型
  validateSchema.blood_type = Joi.string().required();

  // Rh血液型
  validateSchema.blood_type_rh = Joi.string().required();

  // 国籍
  validateSchema.foreigner_flag = Joi.string().required();
  // 国籍が「外国籍」の場合のみ要入力になる項目
  if (foreigner_flag === NATIONALITY_INFO.FOREIGN.ID) {
    // 国名
    validateSchema.nationality = Joi.string().required();

    // 在留資格
    validateSchema.resident_status = Joi.number()
      .min(1)
      .required(); // 「未設定」(0)以外

    // 在留期間満了日
    validateSchema.staying_period_expiration_date = customValidateDateNotAllowEmpty
      .base()
      .validateDate();
  }

  // 経験開始年月日
  validateSchema.experience_start_date = Joi.string().required();

  // ブランク期間(月)
  validateSchema.blank_months = Joi.number().required();

  // 雇入年月日
  validateSchema.employer_in_date = Joi.string().required();

  // 雇入時教育受講有無
  validateSchema.education = Joi.string().required();

  // 能力向上教育受講有無
  validateSchema.ability_improving_education_code = Joi.string().required();

  // 危険有害業務_再発防止教育受講有無
  validateSchema.recurrent_protection_education_code = Joi.string().required();

  // 郵便番号
  validateSchema.postal_code = Joi.string().required();

  // 都道府県
  validateSchema.prefectures = Joi.string().required();

  // 市区町村
  validateSchema.city_name = Joi.string().required();

  // 住所1
  validateSchema.address1 = Joi.string().required();

  // 電話番号
  validateSchema.tel = Joi.string().required();

  return validateSchema;
};

/**
 *
 * */
const workerSafetyBasicInfoService = {
  createValidateSchema,
  createValidateSchemaSafetyDocItem,
};

export default workerSafetyBasicInfoService;



// WEBPACK FOOTER //
// ./src/services/workers/workerSafetyBasicInfo/WorkerSafetyBasicInfoService.js